<form #form="ngForm">
    <div class="app-grid">
        <mat-form-field class="columns-12 no-labels">
            <input matInput name="email" required #emailInput="ngModel" [(ngModel)]="email.address" emailValidator />
            <mat-error *ngIf="emailInput.invalid">{{ emailInput.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
</form>
